import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e12be3a0")

_pushScopeId("data-v-e12be3a0")
const _hoisted_1 = {
  class: "d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed",
  style: {"background-color":"#790008"}
}
const _hoisted_2 = /*#__PURE__*/_createVNode("nav", { class: "navbar navbar-light bg-white" }, [
  /*#__PURE__*/_createVNode("div", { class: "container-fluid" }, [
    /*#__PURE__*/_createVNode("a", {
      class: "navbar-brand",
      href: "#"
    }, [
      /*#__PURE__*/_createVNode("img", {
        src: "media/logos/cimb.png",
        alt: "",
        width: "200"
      })
    ])
  ])
], -1)
const _hoisted_3 = { class: "d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20" }
const _hoisted_4 = { class: "w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "text-center mb-10" }, [
  /*#__PURE__*/_createVNode("h1", {
    class: "mb-3",
    style: {"color":"#790008"}
  }, " Form Pendaftaran Kunjungan ")
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "fw-bold fs-4" }, "Nomor Polisi", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "fw-bold fs-4" }, "Lokasi", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "fw-bold fs-4" }, "Tanggal", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "fw-bold fs-4" }, "Waktu", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_time_select = _resolveComponent("el-time-select")
  const _component_el_form = _resolveComponent("el-form")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_el_form, {
          ref: "formRef",
          model: _ctx.form,
          "label-position": "top",
          "label-width": "auto",
          style: {"max-width":"600px"},
          size: "large"
        }, {
          default: _withId(() => [
            _hoisted_5,
            _createVNode(_component_el_form_item, { prop: "nopol" }, {
              label: _withId(() => [
                _hoisted_6
              ]),
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.nopol,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.nopol = $event)),
                  size: "large"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { prop: "location" }, {
              label: _withId(() => [
                _hoisted_7
              ]),
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.form.location,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.location = $event)),
                  placeholder: "Select",
                  style: {"width":"100%"}
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_option, {
                      label: "",
                      value: ""
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { prop: "date" }, {
              label: _withId(() => [
                _hoisted_8
              ]),
              default: _withId(() => [
                _createVNode(_component_el_date_picker, {
                  class: "form",
                  "disabled-date": _ctx.disabledDate,
                  modelValue: _ctx.form.date,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.date = $event)),
                  type: "date",
                  placeholder: "Pilih tanggal",
                  style: {"width":"100%"},
                  "value-format": "YYYY-MM-DD"
                }, null, 8, ["disabled-date", "modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { prop: "time" }, {
              label: _withId(() => [
                _hoisted_9
              ]),
              default: _withId(() => [
                _createVNode(_component_el_time_select, {
                  modelValue: _ctx.form.time,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.time = $event)),
                  style: {"width":"100%"},
                  start: "08:00",
                  step: "00:15",
                  end: "14:30",
                  placeholder: "Pilih waktu"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ])
  ]))
})